
// src/widgets/SpeedGunWidget.tsx

// Defines the segments for each number from 0 to 9
const sevenSegmentMap: { [key: number]: number[] } = {
    0: [1, 1, 1, 1, 1, 1, 0],
    1: [0, 1, 1, 0, 0, 0, 0],
    2: [1, 1, 0, 1, 1, 0, 1],
    3: [1, 1, 1, 1, 0, 0, 1],
    4: [0, 1, 1, 0, 0, 1, 1],
    5: [1, 0, 1, 1, 0, 1, 1],
    6: [1, 0, 1, 1, 1, 1, 1],
    7: [1, 1, 1, 0, 0, 0, 0],
    8: [1, 1, 1, 1, 1, 1, 1],
    9: [1, 1, 1, 1, 0, 1, 1],
};

function createSevenSegmentDigit(): { element: HTMLDivElement, segments: HTMLDivElement[] } {
    const digit = document.createElement('div');
    digit.className = 'seven-segment-digit';
    const segments: HTMLDivElement[] = [];
    for (let i = 0; i < 7; i++) {
        const segment = document.createElement('div');
        segment.className = `segment segment-${i + 1}`;
        digit.appendChild(segment);
        segments.push(segment);
    }
    return { element: digit, segments };
}

function setDigit(segments: HTMLDivElement[], num: number | null) {
    if (num === null) {
        segments.forEach(segment => segment.classList.remove('on'));
        return;
    }
    const pattern = sevenSegmentMap[num];
    if (pattern) {
        for (let i = 0; i < 7; i++) {
            if (pattern[i] === 1) {
                segments[i].classList.add('on');
            } else {
                segments[i].classList.remove('on');
            }
        }
    }
}

export function SpeedGunWidget(): HTMLElement {
    const widget = document.createElement('div');
    widget.className = 'widget-content speed-gun-widget';

    const display = document.createElement('div');
    display.className = 'speed-display';
    widget.appendChild(display);

    const digits: { element: HTMLDivElement, segments: HTMLDivElement[] }[] = [];
    for (let i = 0; i < 3; i++) {
        const digit = createSevenSegmentDigit();
        display.appendChild(digit.element);
        digits.push(digit);
    }

    const updateSpeed = (newSpeed?: number) => {
        if (newSpeed === undefined || newSpeed === null || newSpeed < 0) {
            setDigit(digits[0].segments, null);
            setDigit(digits[1].segments, null);
            setDigit(digits[2].segments, null);
            return;
        }

        const speedStr = Math.round(newSpeed).toString().padStart(3, '0');
        const hundreds = parseInt(speedStr[0], 10);
        const tens = parseInt(speedStr[1], 10);
        const ones = parseInt(speedStr[2], 10);

        if (newSpeed >= 100) {
            setDigit(digits[0].segments, hundreds);
        } else {
            setDigit(digits[0].segments, null);
        }

        if (newSpeed >= 10) {
            setDigit(digits[1].segments, tens);
        } else {
            setDigit(digits[1].segments, null);
        }
        
        setDigit(digits[2].segments, ones);
    };

    (widget as any).updateSpeed = updateSpeed;
    updateSpeed(); // Call initially to set the display to blank

    return widget;
}
